module.exports = __webpack_public_path__ + "img/SHIPPING.6376979e.svg";